import React from "react";
import {Button, Spinner} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const ButtonWhite = ({styleDefault, styleButton, loading, disabled, ...props}) => {
    const {t} = useTranslation(['common'])

    return <Button variant="" disabled={loading || disabled} style={{...styleDefault, ...styleButton}} {...props}>
        {
            loading ? <>
                <Spinner className="mx-1"
                         as="span"
                         animation="border"
                         size="sm"
                         role="status"
                         aria-hidden="true"
                />
                {t('common:loading')}...
            </> : props.children
        }
    </Button>
}

ButtonWhite.defaultProps = {
    styleDefault: {},
    styleButton: {
        width: "223px",
        height: "47px",
        background: "#ffffff",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "19px",
        borderRadius: "40.5px",
        border: "1px solid #000000"
    }
}

export default ButtonWhite;